import { lazy } from 'react';

export const LazyDocumentPreviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--document-preview-page" */ './document-preview-page'
    ),
);
